// Dependencies
import React from 'react';
import PropTypes from 'prop-types'

// Stateless component / Functional component
const TextAreaField = (props) => (
    <div>
        <label className= "pt-label">{props.label}</label>
        <textarea
            className="pt-input pt-fill"
            onChange={props.onChange}
            type={props.textarea ? 'textarea' : 'text'}
            value={props.value}
        />
    </div>
);

// PropTypes is a way to ensure we are expecting
// certain props that will enable the component to
// function properly.
TextAreaField.propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    textarea: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired
}

TextAreaField.defaultProps = {
    textarea: false,
}

export default TextAreaField;



// WEBPACK FOOTER //
// ./src/components/contactForm/textareaField.jsx